import { render } from "./DocumentsDansukPres.vue?vue&type=template&id=8599cc96&scoped=true"
import script from "./DocumentsDansukPres.vue?vue&type=script&lang=js"
export * from "./DocumentsDansukPres.vue?vue&type=script&lang=js"

import "./DocumentsDansukPres.vue?vue&type=style&index=0&id=8599cc96&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8599cc96"]])

export default __exports__